"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Welcome = void 0;
var Welcome_1 = require("./Welcome");
Object.defineProperty(exports, "Welcome", { enumerable: true, get: function () { return __importDefault(Welcome_1).default; } });
